import { __assign } from 'tslib';
import { clamp } from '../utils.js';
var number = {
  test: function (v) {
    return typeof v === 'number';
  },
  parse: parseFloat,
  transform: function (v) {
    return v;
  }
};
var alpha = __assign(__assign({}, number), {
  transform: clamp(0, 1)
});
var scale = __assign(__assign({}, number), {
  default: 1
});
export { alpha, number, scale };